import axios from "axios";
import { clearSession, getAccessToken } from "./session";

export const API_BASE_URL = (
  process.env.REACT_APP_API_URL ||
  (process.env.NODE_ENV === "production"
    ? "https://api.telegoogle.uz"
    : "http://localhost:8085")
).replace(/\/+$/, "");

const config = axios.create({ baseURL: API_BASE_URL });

config.interceptors.request.use((request) => {
  const token = getAccessToken();
  if (token && !request.headers.Authorization) request.headers.Authorization = `Bearer ${token}`;
  return request;
});

config.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401 && getAccessToken()) {
      clearSession();
      window.location.assign("/");
    }
    return Promise.reject(error);
  }
);

export default config;
